import { isMobile } from 'is-mobile';
export const isMobileWeb: boolean = isMobile();
